<template>
  <v-card outlined style="position:relative">
    <v-card-title>{{title}}</v-card-title>
    <v-chip label style="position: absolute; top:-1px; right: -1px;">{{quantity }}</v-chip>

    <v-card-text class="text-h4 text-center pa-1">
      {{ currencyFormat(amount) }}
    </v-card-text>

  </v-card>
</template>

<script>
import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";

export default {
  name: "DashboardCard",
  mixins: [CurrencyMixin],
  props: {
    title: {type:String},
    quantity: {type: Number},
    amount: {type: Number},
  }
}
</script>

<style scoped>

</style>
